module.exports = __webpack_public_path__ + "static/media/Meme.3acef6d9.png";